import React from "react";
import { Link, useLocation } from "react-router-dom";
import { UserButton } from "@clerk/react";
import "./console-header.scss";

export default function ConsoleHeader() {
  const location = useLocation();
  const currentPath = location.pathname;

  const navLinks = [
    { name: "STUDY", path: "/study" },
    { name: "COURSE", path: "/course" },
    { name: "DSA", path: "/dsa" },
    { name: "RESUME", path: "/resupload" },
    { name: "CODEVID", path: "/codevid" },
  ];

  return (
    <header className="console-global-header">
      <div className="cgh-left">
        <Link to="/" className="cgh-logo" style={{ textDecoration: 'none', color: '#00ff00', fontWeight: 900 }}>RENSHU</Link>
        <nav className="cgh-nav">
          {navLinks.map((link) => {
            const isActive = currentPath.startsWith(link.path);
            return (
              <Link
                key={link.path}
                to={link.path}
                className={`cgh-link ${isActive ? "active" : ""}`}
              >
                [{link.name}]
              </Link>
            );
          })}
        </nav>
      </div>
      
      <div className="cgh-right">
        <div className="cgh-auth">
          <UserButton />
        </div>
      </div>
    </header>
  );
}
